<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol">
      <table class="c-indicator c-indicator-w-100">
        <thead>
          <tr>
            <th class="tab-wid-80">№<br /></th>
            <th class="tab-wid-80">Группа</th>
            <th class="tab-wid-122">
              Код оборудования
            </th>
            <th class="tab-wid-250">
              Вид оборудования
            </th>
            <th class="tab-wid-250">
              Наименование закупаемого оборудования
            </th>
            <th class="tab-wid-250">
              Количество
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in project.PURCHASED_EQUIPMENT.items">
          <System_equipment_list_markirovka
            :item="item"
            :index="index"
            v-bind:key="index"
          ></System_equipment_list_markirovka>
        </tbody>
      </table>
      <div class="add-row" v-show="!$parent.$parent.projectDisabled">
        <a class="link-add-row" v-on:click="addItem">Добавить оборудование</a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import System_equipment_list_markirovka from "@/components/project/form/lists/SystemEquipmentListMarkirovka";
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "System_equipment_markirovka",
  components: {
    System_equipment_list_markirovka
  },
  mounted() {
    this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/group_med_oborudovanie"])
      .then(() => {}, this);
  },
  methods: {
    hasError(col, field) {
      if (
        typeof this.$parent.$parent.systemEquipmentErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.systemEquipmentErrors[col][field] !==
          "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    errorText(col, field) {
      if (
        typeof this.$parent.$parent.systemEquipmentErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.systemEquipmentErrors[col][field] !==
          "undefined"
        ) {
          return this.$parent.$parent.systemEquipmentErrors[col][field];
        }
      }
      return "";
    },
    removeError(col, field) {
      if (
        typeof this.$parent.$parent.systemEquipmentErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.systemEquipmentErrors[col][field] !==
          "undefined"
        ) {
          Vue.delete(this.$parent.$parent.systemEquipmentErrors[col], field);
        }
      }
      return false;
    },
    addItem() {
      if (typeof this.project.PURCHASED_EQUIPMENT === "undefined") {
        this.project.PURCHASED_EQUIPMENT = {
          items: []
        };
      } else if (this.purchasedEquipment !== 21) {
        let t = null;
        t = this.directory.tree_group_med_oborudovanie.filter(
          c => c.UF_IS_SET_BLOCK_FIELD === 1
        );
        console.log("t:", JSON.parse(JSON.stringify(t)));
        if (t.length > 0) {
          console.log("t[0].CHILD:", JSON.parse(JSON.stringify(t[0].CHILD)));
          this.project.PURCHASED_EQUIPMENT.items.push({
            UF_VID_GROUP_ID: t[0].ID,
            UF_VID_ID: t[0].CHILD[0].ID
          });
          console.log(
            "this.project.PURCHASED_EQUIPMENT.items:",
            JSON.parse(JSON.stringify(this.project.PURCHASED_EQUIPMENT.items))
          );
        }
      } else if (this.purchasedEquipment === 21) {
        this.project.PURCHASED_EQUIPMENT.items.push({});
      }
    },
    deleteItem(index) {
      this.project.PURCHASED_EQUIPMENT.items.splice(index, 1);
    }
  },
  computed: {
    ...mapGetters(["directory", "project"]),
    purchasedEquipment() {
      let t = this.directory.tree_industry.filter(
        c => c.ID === this.$parent.project.UF_INDUSTRY_ID
      );
      if (t.length > 0) {
        // console.log(t[0].CODE);
        return t[0].CODE;
      }
      return "";
    }
  }
};
</script>

<style scoped></style>
